export default __webpack_public_path__ + "static/media/withdraw-reward-step4.ec98016d.png";